import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotBell = ({ spotColor = "#E4EDFE", color = "#13126C", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={spotColor}
                d="M19.982 3.299c3.015.85 7.803 2.287 11.293 6.562 3.49 4.288 5.999 11.81 4.036 16.124-1.972 4.3-8.416 5.378-14.091 7.104-5.685 1.738-10.592 4.123-14.02 2.194C3.78 33.355 1.857 27.126.835 21.76-.196 16.394-.307 11.903.695 8.148 1.686 4.393 3.81 1.387 6.228.397c2.428-.977 5.16.05 7.314.913 2.155.863 3.415 1.126 6.44 1.989Z"
            />
            <path
                fill={color}
                fillRule="nonzero"
                d="M18.77 0a4.08 4.08 0 0 1 4.076 3.884 10.458 10.458 0 0 1 6.379 9.63v5.366a3.319 3.319 0 0 1 3.06 3.305v2.041c0 .987-.801 1.784-1.786 1.784H7.04a1.784 1.784 0 0 1-1.786-1.784v-2.041a3.319 3.319 0 0 1 3.06-3.305v-5.365c0-4.256 2.568-8.018 6.38-9.63A4.08 4.08 0 0 1 18.77 0Zm10.965 23.46v-1.275a.768.768 0 0 0-.766-.765 2.294 2.294 0 0 1-2.294-2.294v-5.611a7.907 7.907 0 0 0-5.49-7.53l-.885-.283V4.076a1.53 1.53 0 0 0-3.06 0v1.626l-.886.284a7.91 7.91 0 0 0-5.489 7.529v5.61a2.295 2.295 0 0 1-2.294 2.295.768.768 0 0 0-.766.765v1.275h21.93Zm-15.81 2.55h2.55a2.295 2.295 0 1 0 4.59 0h2.55a4.845 4.845 0 0 1-9.69 0Z"
            />
        </g>
    </SVG>
);

SpotBell.displayName = "SpotBell";
